/**
 * This file is a fixture file for testing all the various planIds
 * that we have active on Stripe.
 *
 * It could also be used to form a lookup table of plan strings to their
 * outputted value, but it's preferable to use "determinePlan" as the
 * definition of what plan a user on may drift over time
 */
export const allPlans = [
    [
        'premium-monthly-v1',
        {
            planId: 'premium-monthly-v1',
            type: 'professional',
            version: 'v1',
            interval: 'monthly',
        },
    ],
    [
        'plan-default-usd-pro_monthly-v2',
        {
            planId: 'plan-default-usd-pro_monthly-v2',
            type: 'professional',
            version: 'v2',
            interval: 'monthly',
            currency: 'usd',
        },
    ],
    [
        'premium-yearly-v1',
        {
            planId: 'premium-yearly-v1',
            type: 'professional',
            version: 'v1',
            interval: 'yearly',
        },
    ],
    [
        'clinic-monthly-v1',
        {
            planId: 'clinic-monthly-v1',
            type: 'clinic',
            version: 'v1',
            interval: 'monthly',
        },
    ],
    [
        'plan-default-usd-pro_yearly-v2',
        {
            planId: 'plan-default-usd-pro_yearly-v2',
            type: 'professional',
            version: 'v2',
            interval: 'yearly',
            currency: 'usd',
        },
    ],
    [
        'clinic-yearly-v1',
        {
            planId: 'clinic-yearly-v1',
            type: 'clinic',
            version: 'v1',
            interval: 'yearly',
        },
    ],
    [
        'plan-default-usd-clinic_monthly-v2',
        {
            planId: 'plan-default-usd-clinic_monthly-v2',
            type: 'clinic',
            version: 'v2',
            interval: 'monthly',
            currency: 'usd',
        },
    ],
    [
        'premium-one-day-v1',
        {
            planId: 'premium-one-day-v1',
            type: 'professional',
            version: 'day',
            interval: 'one',
        },
    ],
    [
        'plan-default-usd-clinic_yearly-v2',
        {
            planId: 'plan-default-usd-clinic_yearly-v2',
            type: 'clinic',
            version: 'v2',
            interval: 'yearly',
            currency: 'usd',
        },
    ],
    [
        'price_1IG38mAbPSoFBZk6M0yErPDx',
        { planId: 'price_1IG38mAbPSoFBZk6M0yErPDx', type: 'unknown' },
    ],
    [
        'plan-default-cad-pro_monthly-v2',
        {
            planId: 'plan-default-cad-pro_monthly-v2',
            type: 'professional',
            version: 'v2',
            interval: 'monthly',
            currency: 'cad',
        },
    ],
    [
        'price_1IG395AbPSoFBZk6pZZtIEfP',
        { planId: 'price_1IG395AbPSoFBZk6pZZtIEfP', type: 'unknown' },
    ],
    [
        'plan-default-eur-pro_monthly-v2',
        {
            planId: 'plan-default-eur-pro_monthly-v2',
            type: 'professional',
            version: 'v2',
            interval: 'monthly',
            currency: 'eur',
        },
    ],
    [
        'plan-default-aud-pro_monthly-v2',
        {
            planId: 'plan-default-aud-pro_monthly-v2',
            type: 'professional',
            version: 'v2',
            interval: 'monthly',
            currency: 'aud',
        },
    ],
    [
        'plan-default-gbp-pro_monthly-v2',
        {
            planId: 'plan-default-gbp-pro_monthly-v2',
            type: 'professional',
            version: 'v2',
            interval: 'monthly',
            currency: 'gbp',
        },
    ],
    [
        'plan-default-cad-pro_yearly-v2',
        {
            planId: 'plan-default-cad-pro_yearly-v2',
            type: 'professional',
            version: 'v2',
            interval: 'yearly',
            currency: 'cad',
        },
    ],
    [
        'plan-default-nzd-pro_monthly-v2',
        {
            planId: 'plan-default-nzd-pro_monthly-v2',
            type: 'professional',
            version: 'v2',
            interval: 'monthly',
            currency: 'nzd',
        },
    ],
    [
        'plan-default-aud-pro_yearly-v2',
        {
            planId: 'plan-default-aud-pro_yearly-v2',
            type: 'professional',
            version: 'v2',
            interval: 'yearly',
            currency: 'aud',
        },
    ],
    [
        'price_1KeibnAbPSoFBZk6iNpgn7E0',
        { planId: 'price_1KeibnAbPSoFBZk6iNpgn7E0', type: 'unknown' },
    ],
    [
        'plan-default-eur-clinic_monthly-v2',
        {
            planId: 'plan-default-eur-clinic_monthly-v2',
            type: 'clinic',
            version: 'v2',
            interval: 'monthly',
            currency: 'eur',
        },
    ],
    [
        'plan-default-gbp-pro_yearly-v2',
        {
            planId: 'plan-default-gbp-pro_yearly-v2',
            type: 'professional',
            version: 'v2',
            interval: 'yearly',
            currency: 'gbp',
        },
    ],
    [
        'plan-default-cad-clinic_monthly-v2',
        {
            planId: 'plan-default-cad-clinic_monthly-v2',
            type: 'clinic',
            version: 'v2',
            interval: 'monthly',
            currency: 'cad',
        },
    ],
    [
        'plan-default-mxn-pro_monthly-v2',
        {
            planId: 'plan-default-mxn-pro_monthly-v2',
            type: 'professional',
            version: 'v2',
            interval: 'monthly',
            currency: 'mxn',
        },
    ],
    [
        'plan-default-gbp-clinic_monthly-v2',
        {
            planId: 'plan-default-gbp-clinic_monthly-v2',
            type: 'clinic',
            version: 'v2',
            interval: 'monthly',
            currency: 'gbp',
        },
    ],
    [
        'plan-default-eur-pro_yearly-v2',
        {
            planId: 'plan-default-eur-pro_yearly-v2',
            type: 'professional',
            version: 'v2',
            interval: 'yearly',
            currency: 'eur',
        },
    ],
    [
        'plan-default-brl-pro_monthly-v2',
        {
            planId: 'plan-default-brl-pro_monthly-v2',
            type: 'professional',
            version: 'v2',
            interval: 'monthly',
            currency: 'brl',
        },
    ],
    [
        'plan-default-aud-clinic_monthly-v2',
        {
            planId: 'plan-default-aud-clinic_monthly-v2',
            type: 'clinic',
            version: 'v2',
            interval: 'monthly',
            currency: 'aud',
        },
    ],
    [
        'plan-default-nzd-pro_yearly-v2',
        {
            planId: 'plan-default-nzd-pro_yearly-v2',
            type: 'professional',
            version: 'v2',
            interval: 'yearly',
            currency: 'nzd',
        },
    ],
    ['plan_HXPUy2AzxFJlWK', { planId: 'plan_HXPUy2AzxFJlWK', type: 'unknown' }],
    [
        'price_1JToHQAbPSoFBZk6YA5uo9mG',
        { planId: 'price_1JToHQAbPSoFBZk6YA5uo9mG', type: 'unknown' },
    ],
    ['plan_GiCFzUeTM6K4w0', { planId: 'plan_GiCFzUeTM6K4w0', type: 'unknown' }],
    [
        'plan-default-inr-clinic_monthly-v2',
        {
            planId: 'plan-default-inr-clinic_monthly-v2',
            type: 'clinic',
            version: 'v2',
            interval: 'monthly',
            currency: 'inr',
        },
    ],
    [
        'plan-default-inr-pro_monthly-v2',
        {
            planId: 'plan-default-inr-pro_monthly-v2',
            type: 'professional',
            version: 'v2',
            interval: 'monthly',
            currency: 'inr',
        },
    ],
    [
        'plan-default-nzd-clinic_monthly-v2',
        {
            planId: 'plan-default-nzd-clinic_monthly-v2',
            type: 'clinic',
            version: 'v2',
            interval: 'monthly',
            currency: 'nzd',
        },
    ],
    [
        'plan-default-cad-clinic_yearly-v2',
        {
            planId: 'plan-default-cad-clinic_yearly-v2',
            type: 'clinic',
            version: 'v2',
            interval: 'yearly',
            currency: 'cad',
        },
    ],
    [
        'plan-default-php-pro_monthly-v2',
        {
            planId: 'plan-default-php-pro_monthly-v2',
            type: 'professional',
            version: 'v2',
            interval: 'monthly',
            currency: 'php',
        },
    ],
    [
        'plan-default-gbp-clinic_yearly-v2',
        {
            planId: 'plan-default-gbp-clinic_yearly-v2',
            type: 'clinic',
            version: 'v2',
            interval: 'yearly',
            currency: 'gbp',
        },
    ],
    [
        'price_1IW2GAAbPSoFBZk6yyjaPTVo',
        { planId: 'price_1IW2GAAbPSoFBZk6yyjaPTVo', type: 'unknown' },
    ],
    [
        'plan-default-brl-clinic_monthly-v2',
        {
            planId: 'plan-default-brl-clinic_monthly-v2',
            type: 'clinic',
            version: 'v2',
            interval: 'monthly',
            currency: 'brl',
        },
    ],
    [
        'plan-default-mxn-clinic_monthly-v2',
        {
            planId: 'plan-default-mxn-clinic_monthly-v2',
            type: 'clinic',
            version: 'v2',
            interval: 'monthly',
            currency: 'mxn',
        },
    ],
    [
        'price_1HSQZcAbPSoFBZk6uS1WgTJ6',
        { planId: 'price_1HSQZcAbPSoFBZk6uS1WgTJ6', type: 'unknown' },
    ],
    [
        'plan-default-php-clinic_monthly-v2',
        {
            planId: 'plan-default-php-clinic_monthly-v2',
            type: 'clinic',
            version: 'v2',
            interval: 'monthly',
            currency: 'php',
        },
    ],
    [
        'price_1JToIJAbPSoFBZk6NLXFmP44',
        { planId: 'price_1JToIJAbPSoFBZk6NLXFmP44', type: 'unknown' },
    ],
    [
        'plan-default-eur-clinic_yearly-v2',
        {
            planId: 'plan-default-eur-clinic_yearly-v2',
            type: 'clinic',
            version: 'v2',
            interval: 'yearly',
            currency: 'eur',
        },
    ],
    ['plan_Ii9antsNFNLfUQ', { planId: 'plan_Ii9antsNFNLfUQ', type: 'unknown' }],
    [
        'price_1JUd99AbPSoFBZk6shYocOin',
        { planId: 'price_1JUd99AbPSoFBZk6shYocOin', type: 'unknown' },
    ],
    [
        'price_1JPsxNAbPSoFBZk6DcQkuVg5',
        { planId: 'price_1JPsxNAbPSoFBZk6DcQkuVg5', type: 'unknown' },
    ],
    [
        'price_1JToJBAbPSoFBZk6758I20Q2',
        { planId: 'price_1JToJBAbPSoFBZk6758I20Q2', type: 'unknown' },
    ],
    ['50% off old user', { planId: '50% off old user', type: 'unknown' }],
    [
        'price_1JToIWAbPSoFBZk6XBxUM2Lo',
        { planId: 'price_1JToIWAbPSoFBZk6XBxUM2Lo', type: 'unknown' },
    ],
    [
        'price_1JToKYAbPSoFBZk6AV9GYpl6',
        { planId: 'price_1JToKYAbPSoFBZk6AV9GYpl6', type: 'unknown' },
    ],
    [
        'price_1JToI8AbPSoFBZk6YO0CSYEZ',
        { planId: 'price_1JToI8AbPSoFBZk6YO0CSYEZ', type: 'unknown' },
    ],
    [
        'price_1JToIfAbPSoFBZk6OB0wIFV1',
        { planId: 'price_1JToIfAbPSoFBZk6OB0wIFV1', type: 'unknown' },
    ],
    [
        'price_1ITq6kAbPSoFBZk6EIoHG2jI',
        { planId: 'price_1ITq6kAbPSoFBZk6EIoHG2jI', type: 'unknown' },
    ],
    [
        'price_1PW4YpAbPSoFBZk67cdaOXHw',
        { planId: 'price_1PW4YpAbPSoFBZk67cdaOXHw', type: 'unknown' },
    ],
    [
        'price_1PptTHAbPSoFBZk6FhBJZ2eL',
        { planId: 'price_1PptTHAbPSoFBZk6FhBJZ2eL', type: 'unknown' },
    ],
    [
        'price_1PDUhNAbPSoFBZk6Zuzmsmtw',
        { planId: 'price_1PDUhNAbPSoFBZk6Zuzmsmtw', type: 'unknown' },
    ],
    [
        'price_1JToLWAbPSoFBZk6s8Kaiygg',
        { planId: 'price_1JToLWAbPSoFBZk6s8Kaiygg', type: 'unknown' },
    ],
    [
        'price_1MBjHrAbPSoFBZk64aughYRm',
        { planId: 'price_1MBjHrAbPSoFBZk64aughYRm', type: 'unknown' },
    ],
    [
        'price_1Pi0kvAbPSoFBZk6llvSEWwx',
        { planId: 'price_1Pi0kvAbPSoFBZk6llvSEWwx', type: 'unknown' },
    ],
    [
        'price_1JO70NAbPSoFBZk6eTxq30HC',
        { planId: 'price_1JO70NAbPSoFBZk6eTxq30HC', type: 'unknown' },
    ],
    [
        'price_1OX4J1AbPSoFBZk6dcgEvInC',
        { planId: 'price_1OX4J1AbPSoFBZk6dcgEvInC', type: 'unknown' },
    ],
    [
        'plan-default-nzd-clinic_yearly-v2',
        {
            planId: 'plan-default-nzd-clinic_yearly-v2',
            type: 'clinic',
            version: 'v2',
            interval: 'yearly',
            currency: 'nzd',
        },
    ],
    [
        'price_1PaNZ9AbPSoFBZk6qaS0e0C3',
        { planId: 'price_1PaNZ9AbPSoFBZk6qaS0e0C3', type: 'unknown' },
    ],
    [
        'price_1KTpknAbPSoFBZk6WCHtkktG',
        { planId: 'price_1KTpknAbPSoFBZk6WCHtkktG', type: 'unknown' },
    ],
    [
        'plan-default-brl-clinic_yearly-v2',
        {
            planId: 'plan-default-brl-clinic_yearly-v2',
            type: 'clinic',
            version: 'v2',
            interval: 'yearly',
            currency: 'brl',
        },
    ],
    [
        'price_1JToL8AbPSoFBZk6zmqt7s7C',
        { planId: 'price_1JToL8AbPSoFBZk6zmqt7s7C', type: 'unknown' },
    ],
    [
        'price_1PiH3aAbPSoFBZk6TlXTLPL5',
        { planId: 'price_1PiH3aAbPSoFBZk6TlXTLPL5', type: 'unknown' },
    ],
    [
        'price_1PaOuuAbPSoFBZk6WZ1Gsp8c',
        { planId: 'price_1PaOuuAbPSoFBZk6WZ1Gsp8c', type: 'unknown' },
    ],
    [
        'price_1PddXIAbPSoFBZk62tQtQ1vq',
        { planId: 'price_1PddXIAbPSoFBZk62tQtQ1vq', type: 'unknown' },
    ],
    [
        'price_1Q5VOsAbPSoFBZk6WnlDAdxd',
        { planId: 'price_1Q5VOsAbPSoFBZk6WnlDAdxd', type: 'unknown' },
    ],
    [
        'price_1JToIoAbPSoFBZk6GVfGjRQV',
        { planId: 'price_1JToIoAbPSoFBZk6GVfGjRQV', type: 'unknown' },
    ],
    [
        'price_1LDAarAbPSoFBZk64ufLxl2G',
        { planId: 'price_1LDAarAbPSoFBZk64ufLxl2G', type: 'unknown' },
    ],
    [
        'price_1JPsvPAbPSoFBZk6TJcJoZgX',
        { planId: 'price_1JPsvPAbPSoFBZk6TJcJoZgX', type: 'unknown' },
    ],
    [
        'price_1JUVnRAbPSoFBZk6QQmALHxr',
        { planId: 'price_1JUVnRAbPSoFBZk6QQmALHxr', type: 'unknown' },
    ],
    [
        'price_1MBjwoAbPSoFBZk6O57ZuJ0H',
        { planId: 'price_1MBjwoAbPSoFBZk6O57ZuJ0H', type: 'unknown' },
    ],
    [
        'price_1PdccJAbPSoFBZk6fFclHEe4',
        { planId: 'price_1PdccJAbPSoFBZk6fFclHEe4', type: 'unknown' },
    ],
    [
        'price_1MBjwzAbPSoFBZk6YfjfhtMr',
        { planId: 'price_1MBjwzAbPSoFBZk6YfjfhtMr', type: 'unknown' },
    ],
    [
        'price_1JToJ0AbPSoFBZk6Md4Xsya2',
        { planId: 'price_1JToJ0AbPSoFBZk6Md4Xsya2', type: 'unknown' },
    ],
];
